import GenericSlider from '../generic-slider/generic-slider';
import 'lightgallery.js';
import 'lg-fullscreen.js';
import 'lg-zoom.js';
import 'lightgallery.js/dist/css/lightgallery.css';
import { pushTrackingEventToDataLayer } from '../../helpers/data-layer-helper';
import { SHOW_3D_VISIT_OPENED } from '../../events/data-layer-events';

export default class GallerySlider extends GenericSlider {
  bind() {
    super.bind();
    this._initGallery();
    this._initEventHandlers();
  }

  _initGallery() {
    // configure and initialize lightgallery.js
    lightGallery(this.dom.component, {
      selector: '.js-gallery-item',
      download: false,
      counter: true,
      iframeMaxWidth: '80%',
    });
  }

  _initEventHandlers() {
    const button = this.dom.component.querySelector('.js-3d-visit-laucher');
    if (button) {
      button.addEventListener('click', () => {
        pushTrackingEventToDataLayer(SHOW_3D_VISIT_OPENED);
      });
    }

    // prevent light gallery from opening when clicking download links
    const downloadLinks = this.dom.component.querySelectorAll('.js-gallery-item .download-link');
    for (let i = 0; i < downloadLinks.length; i++) {
      downloadLinks[i].addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  }
}
